import React from "react";
import { useTranslation } from "react-i18next";

import {
  sponsoredByLogo,
  supportedByLogo,
  ticketingByLogo,
  djPerformByLogo,
  presentedByLogo,
  communityPartnerLogo,
  mediaByLogo,
  venueByLogo,
} from "utils/constants/data";

// Images & Icons
import home_banner_desktop from "assets/images/home_banner_desktop.png";

function OurSponsors({ landingPage }) {
  const { t } = useTranslation();

  const handleOnClickLogo = (url) => {
    if (url) window.open(url, "_blank", "noopener,noreferrer");
  };

  const sponsors = {
    sponsoredBy: (
      <div className="grid items-center grid-cols-4 gap-4 place-items-center app-animation-translate-start">
        {sponsoredByLogo &&
          sponsoredByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                alt="client-logo"
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain cursor-pointer"
                onClick={() => handleOnClickLogo(logo.href)}
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    ticketingSytem: (
      <div className="grid items-center grid-cols-1 gap-4 place-items-center app-animation-translate-start">
        {ticketingByLogo &&
          ticketingByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[125px] sm:max-w-[250px] object-contain cursor-pointer"
                onClick={() => handleOnClickLogo(logo.href)}
                alt="client-logo"
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    djPerformance: (
      <div className="grid items-center grid-cols-1 gap-4 place-items-center app-animation-translate-start">
        {djPerformByLogo &&
          djPerformByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                alt="client-logo"
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    venuePartner: (
      <div className="grid items-center grid-cols-1 gap-4 place-items-center app-animation-translate-start">
        {venueByLogo &&
          venueByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[125px] sm:max-w-[250px] object-contain cursor-pointer"
                alt="client-logo"
                onClick={() => handleOnClickLogo(logo.href)}
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    mediaPartner: (
      <div className="grid items-center grid-cols-1 gap-4 place-items-center app-animation-translate-start">
        {mediaByLogo &&
          mediaByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[75px] sm:max-w-[150px] object-contain cursor-pointer"
                alt="client-logo"
                onClick={() => handleOnClickLogo(logo.href)}
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    supportedBy: (
      <div className="grid items-center grid-cols-4 gap-4 place-items-center app-animation-translate-start">
        {supportedByLogo &&
          supportedByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain cursor-pointer"
                alt="client-logo"
                onClick={() => handleOnClickLogo(logo.href)}
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    presentedBy: (
      // <div className="grid items-center grid-cols-4 gap-4 place-items-center app-animation-translate-start">
      //   {presentedByLogo &&
      //     presentedByLogo.map((logo) => {
      //       return (
      //         <img
      //           src={logo && logo.image_url}
      //           className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain cursor-pointer"
      //           alt="client-logo"
      //           onClick={() => handleOnClickLogo(logo.href)}
      //         />
      //       );
      //     })}
      //   {/* <p><b>{t('manyMore')}</b></p> */}
      // </div>
      <div className="flex flex-wrap items-center justify-center gap-4 app-animation-translate-start">
        {presentedByLogo &&
          presentedByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                alt="client-logo"
                className="h-full w-full max-w-[75px] sm:max-w-[150px] object-contain cursor-pointer"
                onClick={() => handleOnClickLogo(logo.href)}
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    communityPartner: (
      <div className="grid items-center grid-cols-4 gap-4 place-items-center app-animation-translate-start">
        {communityPartnerLogo &&
          communityPartnerLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain cursor-pointer"
                alt="client-logo"
                onClick={() => handleOnClickLogo(logo.href)}
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
  };

  return (
    <div>
      {!landingPage && (
        <section>
          <div className="relative">
            {/* home banner desktop size */}
            <img
              // src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/1c0610da06e3edba525e31bbf4bf526fa276d28803c039a64992d024874448b71b02826c5169acbf1c7c61b0dd764488a8a0bf8cd98872c2474650c847a0ffe234f1c22d82f685685cc5bfa38d5bd67b3cfa88080b46a965d68d693de5546d5439ef6d2d5800e97258a00974dc45dfebf67e847305ed821e943f/file-1736775970398.jpg"
              src={home_banner_desktop}
              alt="main"
              className="object-cover object-center w-full max-h-40 sm:max-h-60"
            />
            <div className="absolute top-0 bottom-0 left-0 right-0 text-white bg-black/60">
              <div className="flex flex-col items-center justify-center h-full gap-4 app-main-container sm:gap-8">
                <p className="max-w-md px-8 text-lg font-semibold text-center sm:text-3xl sm:font-bold app-animation-translate-start">
                  {t("ourSponsorsBanner")}
                </p>
              </div>
            </div>
          </div>
        </section>
      )}
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start">
            {t("sponsoredBy")}
          </p>
          <div className="max-w-2xl mx-auto text-sm text-app-blue-3 sm:text-base">
            {sponsors.sponsoredBy}
          </div>
        </div>
      </section>
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start">
            {t("eTicketingSystem")}
          </p>
          <div className="max-w-2xl mx-auto text-sm text-app-blue-3 sm:text-base">
            {sponsors.ticketingSytem}
          </div>
        </div>
      </section>
      {/* <section>
        <div className='space-y-8 app-main-container'>
          <p className='text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start'>
            {t('djPerformance')}
          </p>
          <div className='max-w-2xl mx-auto text-sm text-app-blue-3 sm:text-base'>{sponsors.djPerformance}</div>
        </div>
      </section> */}
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start">
            {t("venuePartner")}
          </p>
          <div className="max-w-2xl mx-auto text-sm text-app-blue-3 sm:text-base">
            {sponsors.venuePartner}
          </div>
        </div>
      </section>
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start">
            {t("mediaPartner")}
          </p>
          <div className="max-w-2xl mx-auto text-sm text-app-blue-3 sm:text-base">
            {sponsors.mediaPartner}
          </div>
        </div>
      </section>
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start">
            {t("supportedBy")}
          </p>
          <div className="max-w-2xl mx-auto text-sm text-app-blue-3 sm:text-base">
            {sponsors.supportedBy}
          </div>
        </div>
      </section>
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start">
            {t("presentedBy")}
          </p>
          <div className="max-w-2xl mx-auto text-sm text-app-blue-3 sm:text-base">
            {sponsors.presentedBy}
          </div>
        </div>
      </section>
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start">
            {t("communityPartner")}
          </p>
          <div className="max-w-2xl mx-auto text-sm text-app-blue-3 sm:text-base">
            {sponsors.communityPartner}
          </div>
        </div>
      </section>
    </div>
  );
}

export default OurSponsors;
